import React from 'react';
import { Box, Container, Grid, Typography, Link, IconButton, TextField, Button } from '@mui/material';
import { Facebook, Twitter, Instagram, LinkedIn } from '@mui/icons-material';
import { useTheme, alpha } from '@mui/material/styles';

const socialLinks = [
  { icon: Facebook, url: 'https://facebook.com' },
  { icon: Twitter, url: 'https://twitter.com' },
  { icon: Instagram, url: 'https://instagram.com' },
  { icon: LinkedIn, url: 'https://linkedin.com' },
];

const Footer = () => {
  const theme = useTheme();


  return (
    <Box component="footer" sx={{
      mt: 8,
      background: `linear-gradient(135deg, ${theme.palette.primary.light} 20%, ${theme.palette.primary.main} 90%)`,
      color: theme.palette.getContrastText(theme.palette.primary.main),
      position: 'relative',
      pt: 6,
      pb: 4,
    }}>
      {/* Decorative wave divider */}
      <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', overflow: 'hidden', lineHeight: 0, transform: 'translateY(-100%)' }}>
        <svg
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
          style={{ display: 'block', width: 'calc(100% + 1.3px)', height: 60 }}
        >
          <path
            d="M0,0 V50 C150,100 350,0 600,50 C850,100 1050,0 1200,50 V0 H0 Z"
            fill={theme.palette.background.paper}
          />
        </svg>
      </Box>

      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* About */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" color='secondary' gutterBottom sx={{ fontWeight: 'bold' }}>
              Software
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.85 }}>
              My Company is dedicated to delivering innovative solutions that empower businesses worldwide. We value excellence, creativity, and community.
            </Typography>
          </Grid>

          {/* Navigation Links */}
          <Grid item xs={6} sm={3} md={2}>
            <Typography color='secondary'  variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
              Quick Links
            </Typography>
            {['Home', 'Solutions', 'Pricing', 'Contact'].map((text) => (
              <Link
                key={text}
                href={`#${text.toLowerCase()}`}
                color="inherit"
                underline="hover"
                display="block"
                sx={{ mt: 0.5 }}
              >
                {text}
              </Link>
            ))}
          </Grid>

          {/* Resources */}
          <Grid item xs={6} sm={3} md={2}>
            <Typography color='secondary' variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
              Resources
            </Typography>
            {['Login', 'Register', 'Privacy Policy'].map((text) => (
              <Link
                key={text}
                href={`/${text.replace(/ /g, '-').toLowerCase()}`}
                color="inherit"
                underline="hover"
                display="block"
                sx={{ mt: 0.5 }}
              >
                {text}
              </Link>
            ))}
          </Grid>

          {/* Newsletter */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography color='secondary' variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
              Stay in the Loop
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.85, mb: 2 }}>
              Subscribe to our newsletter for the latest updates and offerings.
            </Typography>
            <Box component="form" sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
              <TextField
                variant="filled"
                size="small"
                placeholder="Your email"
                required
                sx={{
                  background: theme.palette.background.paper,
                  borderRadius: 1,
                  flexGrow: 1,
                  '& .MuiFilledInput-root': { background: theme.palette.background.paper },
                }}
              />
              <Button type="submit" variant="contained" sx={{ whiteSpace: 'nowrap' }}>
                Subscribe
              </Button>
            </Box>
          </Grid>
        </Grid>

        {/* Bottom Bar */}
        <Box sx={{
          borderTop: `1px solid ${alpha(theme.palette.common.white, 0.2)}`,
          mt: 6,
          pt: 3,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
        }}>
          <Typography variant="body2" sx={{ opacity: 0.75 }}>
            &copy; {new Date().getFullYear()} LAG services. All rights reserved.
          </Typography>

          <Box>
            {socialLinks.map(({ icon: Icon, url }, idx) => (
              <IconButton
                key={idx}
                component="a"
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: 'white', transition: 'transform 0.2s', '&:hover': { transform: 'scale(1.1)' } }}
              >
                <Icon sx={{ fontSize: 24 }} />
              </IconButton>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;